import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import evening1 from './pictures/eveningwithindustry.jpg';
import evening2 from './pictures/eveningwithindustry2.jpg';
import evening3 from './pictures/eveningwithindustry3.jpg';
import evening4 from './pictures/eveningwithindustry4.jpg';

const Evening = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Allen School Evening with Industry!</h2>
                    <p class="site-post-meta">February 19th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    This past Wednesday, the Allen School successfully hosted the Allen School Evening with Industry for the first time! We were joined by nearly 20 industry professionals from the following companies: Google, Microsoft, Netflix, JPMorgan Chase, Pinterest, Blue Origin, Hiya, and Promise.

                    <br></br>
                    <br></br>
                    
                    There was an amazing Allen School alumni panel where we got to hear about the early career life following graduation from the Allen School. Students were then able to have conversations with the industry representatives in roundtable rotations, many of whom were UW alum, but also in diverse stages of their careers and in various sectors of the industry. The evening was also accompanied by Mediterranean food for dinner.

                    <br></br>
                    <br></br>
                    
                    Thank you to everyone who joined us despite the rescheduling and a busy week!

                    We hope to see you all at the Allen School Evening with Industry next year!

                    </p>
                    <img src={evening1} alt="pic1 "/>
                    <img src={evening2} alt="pic2 "/>
                    <img src={evening3} alt="pic3 "/>
                    <img src={evening4} alt="pic4 "/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Evening;
